import "./Footer.css";

function Footer() {
  return (
    <>
      <footer className="footer">
        <hr className="footer-line" />
        <p className="footer-text">
          2-Minute Power Plan: Turn Intent into Action!         
        </p>
        <p className="footer-name">
          Designed & Developed by <strong>Alishba</strong>
        </p>
      </footer>
    </>
  );
}

export default Footer;
